import { PaytrieAPI } from '@paytrie/client'

import { configurePaytrieClient } from './apiClient'

const KYC_ERROR_MESSAGE =
  'Unfortunately we were unable to process your request at this time. Please try again later or contact us at support@paytrie.com'

export type KycRedirectSuccess = { ok: true; url: string }

export type KycRedirectFailure = {
  ok: false
  reason: 'already_complete' | 'error'
  message: string
}

export type KycRedirectResult = KycRedirectSuccess | KycRedirectFailure

const getApiErrorMessage = (
  data: unknown,
  fallback = KYC_ERROR_MESSAGE
): string => {
  if (
    data &&
    typeof data === 'object' &&
    'errors' in data &&
    Array.isArray((data as { errors?: Array<{ message?: string }> }).errors)
  ) {
    const message = (data as { errors?: Array<{ message?: string }> })
      .errors?.[0]?.message
    if (message) return message
  }
  return fallback
}

export const startKycRedirect = async (): Promise<KycRedirectResult> => {
  try {
    if (!configurePaytrieClient()) {
      return { ok: false, reason: 'error', message: KYC_ERROR_MESSAGE }
    }

    const res = await PaytrieAPI.getUsersMeKycUrl()

    if (res.status === 200) {
      return { ok: true, url: res.data.data.url }
    }

    if (res.status === 400) {
      return { ok: false, reason: 'already_complete', message: '' }
    }

    return {
      ok: false,
      reason: 'error',
      message: getApiErrorMessage(res.data),
    }
  } catch {
    return { ok: false, reason: 'error', message: KYC_ERROR_MESSAGE }
  }
}
